import angular from 'angular';

class VideoService {
  constructor(BaseService, Constants, Utils, ngDialog, $rootScope) {
    'ngInject';

    Object.assign(this, { ...BaseService,
      Constants,
      Utils,
      ngDialog,
      $rootScope
    });
  }

  getQueue() {
    return this.$http.get(this.Endpoints.queue.base);
  }

  createCall(queueId) {
    return this.$http.post(`${this.API_URL}/admin/videocalls`, {
      queue_entry_id: queueId
    });
  }

  createPhoneCallSession(order_id) {
    return this.$http.post(`${this.API_URL}/admin/phonecalls`, {
      order_id: order_id
    });
  }

  makePhoneCall(phonecall_id, phone_number) {
    return this.$http.put(`${this.API_URL}/admin/phonecalls/` + phonecall_id, {
      phone_number: phone_number
    });
  }

  getPhoneCallSession(phonecall_id) {
    return this.$http.get(`${this.API_URL}/admin/phonecalls/` + phonecall_id);
  }

  hangupPhoneCall(phonecall_id) {
    return this.$http.delete(`${this.API_URL}/admin/phonecalls/` + phonecall_id);
  }

  updateCall(callId, ended = 'now', issues = []) {
    return this.$http.put(`${this.API_URL}/admin/videocalls/${callId}`, {
      ended,
      issues
    });
  }

  getCall(callId) {
    return this.$http.get(`${this.API_URL}/admin/videocalls/${callId}`);
  }

  getIssues() {
    return this.$http.get(`${this.API_URL}/admin/videocalls/issues`, {
      loadingText: 'Loading SLV Issues'
    });
  }

  removeQueueEntry(queueItem = {}) {
    return this.$http.delete(this.Endpoints.queue.one.replace(':id', queueItem.id));
  }

  nullQueueSession(queueItem = {}) {
    return this.$http.put(this.Endpoints.queue.one.replace(':id', queueItem.id), {
      video_call_id: null //session_id: null,
      //session_token: null,

    });
  }

  audit(code, user_id, task_id) {
    return this.$http.post(this.Endpoints.queue.audit, {
      code,
      user_id,
      task_id
    });
  }

  updateTask(taskId, status) {
    return this.$http.put(`${this.API_URL}/tasks/${taskId}/status`, {
      value: status
    });
  }
  /* {
    SLV_AVAILABILITY: "on",
    SLV_BUSY: "on"
  } */


  update(status) {
    return this.$http.put(this.Endpoints.business.slv, status);
  }

  updateSlv(status, slvState) {
    return this.$http.put(this.Endpoints.business.slvState.replace(':code', slvState), {
      slv_enabled: status
    });
  }

  openHangupModal(task, call, queue_entry) {
    var this2 = this;

    if (!this2.dialog) {
      // This is to stop checking active videocalls temporarilly
      // And hide "Hang-up and Redo Video Call" button
      // While doctor is assessing the videocall
      this2.$rootScope.assessingVideoCall = true; // this2.$rootScope.numActiveCalls = 0;

      this2.dialog = this2.ngDialog.open({
        templateUrl: 'app/components/tokbox/hangup.modal.html',
        closeByEscape: false,
        closeByNavigation: false,
        closeByDocument: false,
        controller: ["$scope", "issues", ($scope, issues) => {
          'ngInject';

          $scope.issues = issues;
          $scope.selectedIssues = [];

          $scope.submit = newStatus => {
            if (!$scope.selectedIssues.length) {
              $scope.error = 'Please select at least one option';
              return;
            }

            $scope.closeThisDialog({
              newStatus,
              issues: $scope.selectedIssues.map(issue => issue.code)
            });
          };
        }],
        resolve: {
          issues: () => this2.getIssues().then(({
            data
          }) => data)
        },
        preCloseCallback: ({
          newStatus,
          issues
        }) => {
          this2.dialog = null;

          if (isNaN(newStatus)) {
            return;
          } // TO CANCEL THE VIDEO QUALITY STATS TIMER


          this2.$rootScope.$broadcast('videocall:publisher-update', '');
          this2.$rootScope.$broadcast('videocall:subscriber-update', '');
          this2.$rootScope.$broadcast('videocall:cancel-stats-timer', ''); // Possible new statuses:
          // 3: approved, patient passed video consultation
          // 4: rejected, patient needs to redo video
          // 5: closed, patient did not pass video consultation

          this2.updateCall(call.id, 'now', issues).then(() => {
            const {
              Approved,
              Closed,
              Rejected
            } = this2.Constants.VisitStatuses;

            if (queue_entry) {
              if (newStatus === Approved || newStatus === Rejected) {
                // newStatus === 3 || newStatus === 5
                // If approved or rejected, remove patient from
                // the queue and update newStatus appropriately
                this2.removeQueueEntry(queue_entry).finally(() => {
                  // CLEAR CACHE FOR QUEUE ENTRY (PENDING)
                  // this.visit.queue_entry = null;
                  this2.$rootScope.$broadcast('videocall:clear-queue-entry');
                  this2.updateTaskVideoCall(task, newStatus);
                  this2.$rootScope.assessingVideoCall = false;
                  this2.$rootScope.$broadcast('videocall:finished');
                  if (newStatus === Approved) this2.$rootScope.$broadcast('videocall:approved');
                });
              } else if (newStatus === Closed) {
                // newStatus === 4
                // If closed (to redo the video), null out the video call id
                // and update task newStatus to closed */
                this2.nullQueueSession(queue_entry).finally(() => {
                  this2.updateTaskVideoCall(task, newStatus);
                  this2.$rootScope.assessingVideoCall = false;
                  this2.$rootScope.$broadcast('videocall:finished'); // On "redo" we also resize the video modal window to the initial size
                  // $(".ngdialog-content").css("resize", "unset");
                  // $(".ngdialog-content").css("height", "120px");
                  // $(".ngdialog-content").css("width", "290px");
                  // $(".tokbox-body").css("height", "70px");
                });
              }
            } else {
              this2.updateTaskVideoCall(task, newStatus);
              this2.$rootScope.assessingVideoCall = false;
              this2.$rootScope.$broadcast('videocall:finished');
            }
          }).catch(err => {
            this2.$rootScope.assessingVideoCall = false;
            this2.$rootScope.$broadcast('videocall:finished');
            this2.Utils.createErrorToast(err, 'Failed to hang up the video call.');
          });
        }
      });
    }
  }

  updateTaskVideoCall(task, taskStatus) {
    this.updateTask(task.id, taskStatus).then(() => {
      /*
      this.initialized = false;
      this.call = null;
      this.audioEnabled = true;
      this.task.status = taskStatus;
      publisher = null;
      this.fullscreen = false;
      */
      if (this.$rootScope.videoSession) {
        this.$rootScope.videoSession.disconnect();
      }

      this.$rootScope.videoSession = null;
      this.$rootScope.$broadcast('tokbox:task-updated', {
        taskStatus: taskStatus
      });
      this.$rootScope.$broadcast('visit:refresh');
    }).catch(err => {
      this.Utils.createErrorToast(err, 'Failed to update Video task.');
    }).finally(() => {});
  }

  completeTaskVideoCall(task) {
    const {
      Approved,
      Closed,
      Rejected
    } = this.Constants.VisitStatuses;
    this.updateTask(task.id, Approved).then(() => {
      this.$rootScope.$broadcast('slv-task-approval:success');
      this.$rootScope.$broadcast('videocall:approved');

      if (this.$rootScope.videoSession) {
        this.$rootScope.videoSession.disconnect();
      }

      this.$rootScope.videoSession = null;
      this.$rootScope.$broadcast('tokbox:task-updated', {
        taskStatus: Approved
      });
      this.$rootScope.$broadcast('visit:refresh');
    }).catch(err => {
      this.$rootScope.$broadcast('slv-task-approval:fail');
      this.Utils.createErrorToast(err, 'Failed to update Video task.');
    }).finally(() => {});
  }

}

VideoService.$inject = ["BaseService", "Constants", "Utils", "ngDialog", "$rootScope"];
angular.module('pims').service('VideoService', VideoService);